import React, { useMemo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { toast } from 'react-toastify';

import { useOrderDetailContext } from 'providers/OrderDetailProvider';

import Table from 'components/common/Table';
import OrderInvoiceExpandedRow from 'components/add_order/order/OrderDetail/OrderInvoices/OrderInvoiceExpandedRow';

import { shipmentApi } from 'api';
import { ORDER_DETAIL_INVOICES_COLUMNS } from 'constants/order';
import { generateInvoicePdf } from 'utils/pdfGenerators';

const OrderInvoices = ({ orderId }) => {
  const { orderDetailData } = useOrderDetailContext();

  const handlePrintPdf = async shipmentId => {
    try {
      const response = await shipmentApi.getInvoiceDetail(shipmentId);

      generateInvoicePdf(response);
    } catch (error) {
      toast.error('Error generating PDF', error);
    }
  };

  const extendedColumns = useMemo(() => {
    const pdfColumn = {
      accessorKey: 'none',
      header: '',
      enableSorting: false,
      cell: ({ row: { original } }) => {
        const { shipment } = original;

        return (
          <FontAwesomeIcon
            className="cursor-pointer"
            icon="file-alt"
            onClick={() => handlePrintPdf(shipment.id)}
          />
        );
      },
    };

    return [...ORDER_DETAIL_INVOICES_COLUMNS, pdfColumn];
  }, []);

  return (
    <Table
      title={`Order #${orderDetailData?.channelOrderId} Invoices`}
      apiService={shipmentApi}
      columns={extendedColumns}
      fetchConfig={{
        method: 'getInvoices',
      }}
      resourceId={orderId}
      enablePagination={false}
      renderExpandedRow={row => (
        <OrderInvoiceExpandedRow invoice={row.original} />
      )}
    />
  );
};

export default OrderInvoices;
